import { createStyles } from '@material-ui/core/styles';

import fonts from '../fonts';

export default createStyles({
  root: {
    '&.MuiTab-root': {
      fontSize: fonts.sizes.small,
      padding: '15px 24px 17px 24px',
      minWidth: 0,
      maxWidth: '400px',
    },
    '&.MuiTab-textColorInherit': {
      opacity: 1,
    },
  },
});
